import React, { Fragment, memo } from 'react';
import { useIntl } from 'react-intl';
import PropTypes from 'prop-types';
import { ConsentRenderView } from '../ConsentRenderView';
import { DEFAULT_EMPTY_VALUE } from '../../../../../constants/strings';

const ConsentFormsList = ({
  allConsents,
  dateTime,
  organizationName,
  patientUserInfoId,
  serviceName,
  title,
}) => {
  const isConsentListEmpty = !allConsents.length;

  const { formatMessage } = useIntl();

  const consentVersion = formatMessage({
    id: 'appointment.consent.consentVersion',
  });

  return (
    <Fragment>
      {title}
      {isConsentListEmpty ? (
        <div>{DEFAULT_EMPTY_VALUE}</div>
      ) : (
        allConsents.map(consent => {
          const { id, name, fileUrl, accepted, version, consentType } = consent;

          return (
            <ConsentRenderView
              id={id}
              accepted={accepted}
              fileUrl={fileUrl}
              allConsents={allConsents}
              currentConsent={consent}
              name={name}
              version={version}
              key={id}
              consentType={consentType}
              formatMessage={formatMessage}
              organizationName={organizationName}
              serviceName={serviceName}
              startTime={dateTime}
              consentVersionTitle={consentVersion}
              patientUserInfoId={patientUserInfoId}
            />
          );
        })
      )}
    </Fragment>
  );
};

ConsentFormsList.propTypes = {
  allConsents: PropTypes.array.isRequired,
  dateTime: PropTypes.string,
  organizationName: PropTypes.string,
  patientUserInfoId: PropTypes.number,
  serviceName: PropTypes.string,
  title: PropTypes.node,
};

export default memo(ConsentFormsList);



// WEBPACK FOOTER //
// ./src/components/Healthboard/Components/VisitConsents/ConsentFormsList/index.jsx